/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Hold_Release_FailedInputs */

const en_inventory_hold_release_failed = /** @type {(inputs: Inventory_Hold_Release_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to release hold`)
};

const es_inventory_hold_release_failed = /** @type {(inputs: Inventory_Hold_Release_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo liberar el apartado`)
};

/**
* | output |
* | --- |
* | "Failed to release hold" |
*
* @param {Inventory_Hold_Release_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_hold_release_failed = /** @type {((inputs?: Inventory_Hold_Release_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Hold_Release_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_hold_release_failed(inputs)
	return es_inventory_hold_release_failed(inputs)
});